import get from "lodash/get";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import Paper from "@material-ui/core/Paper";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import noReportData from "Assets/Svg/no-report-data.svg";
import { instance } from "../../../Actions/AxiosInstance";
import { ChangeLanguage } from "../../../Actions/LanguageAction";
import AutoReport from "./AutoReport";
import OneTimeReport from "./OneTimeReport";
import SendReport from "./SendReport";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
    height: "50%",
  },
  typography: {
    // padding: theme.spacing.unit * 3,
  },
});

class ReportRobo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      genType: null,
      autoRep: false,
      oneTime: false,
      GenerationType: [],
      ReportCatagory: [],
      FrequencyType: [],
      stages: [],
      employeementtype: [],
      selectedemployeementtype: [
        { displayvalue: 1, displayname: "Full Time" },
        { displayvalue: 2, displayname: "Part Time" },
        { displayvalue: 3, displayname: "Internship" },
        { displayvalue: 4, displayname: "Apprenticeship" },
        { displayvalue: 5, displayname: "Contract" },
        { displayvalue: 6, displayname: "Consultant" },
        { displayvalue: 7, displayname: "Labor" },
        { displayvalue: 8, displayname: "Freelancer" },
        { displayvalue: 9, displayname: "Vendor" },
      ],
      selectedreviewform: null,
      disableGen: false,
      fromDate: "",
      toDate: "",
      saveReportFlag: "",
      selectedStage: [
        { displayname: "Probation", displayvalue: 1 },
        { displayname: "Confirmed", displayvalue: 2 },
        { displayname: "Training", displayvalue: 3 },
        { displayname: "PIP", displayvalue: 4 },
        { displayname: "On Notice", displayvalue: 5 },
        { displayname: "Resigned", displayvalue: 6 },
        { displayname: "Terminated", displayvalue: 7 },
        { displayname: "New", displayvalue: 8 },
      ],
      mainempList: [],
      // selectGeneration: {
      //   displayname: "Generate Now",
      //   displayvalue: 1,
      // },
    };
    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentDidMount() {
    // window.addEventListener("beforeunload", this.onBeforeUpload);
    this.getDropList();
    this.getSubReport();
    this.getStage();
    this.getEmployeementtype();
    this.getEmployeeDetails();
  }

  getEmployeeDetails = () => {
    const data = {
      accountid: this.state.accountid,
      statusid: null,
      subscriptionid: this.state.subscriptionid,
      featurekey: "reportRobo",
      stageids: "1,2,3,4,5,8",
    };
    data.employmenttypeids = this.state.selectedemployeementtype
      ? this.state.selectedemployeementtype.map((x) => x.displayvalue).join(",")
      : this.props.selectedemployeementtype
      ? this.props.selectedemployeementtype.map((x) => x.displayvalue).join(",")
      : null;
    // data.stageids = selectedStage ? selectedStage.map((x) => x.displayvalue).join(",") : this.props.selectedStage ? this.props.selectedStage.map((x) => x.displayvalue).join(",") : null;
    const URL = `subscription/getemployeelist`;
    // let URL = `subscription/getemployeelist/${this.state.accountid}/${this.state.subscriptionid}/1`
    instance.post(URL, data).then(
      (response) => {
        if (response.data.result) {
          this.setState({ mainempList: [...response.data.result] });
        }
      },
      (error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      },
    );
  };

  _setState = (key, value) => {
    try {
      this.setState({ [key]: value });
    } catch (err) {}
  };

  componentWillUnmount() {
    // window.removeEventListener("beforeunload", this.onBeforeUpload);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  getReportDataById() {
    instance
      .get(`reportrobo/reportbyid/${this.props.updateId}`)
      .then((response) => {
        this.setState({ updateData: response.data.result }, () => {
          let selectSubReport;
          this.state.SubReportCatagory &&
            this.state.SubReportCatagory.forEach((x) => {
              if (
                x.reportcatagoryid ==
                this.state.updateData.ReportData[0].reportcatagoryid
              ) {
                x.options.forEach((y) => {
                  if (
                    y.displayvalue ==
                    this.state.updateData.ReportData[0].reporttypeid
                  ) {
                    selectSubReport = y;
                  }
                });
              }
            });
          const selectGeneration = this.state.GenerationType.find(
            (x) => x.displayvalue == 2,
          );
          this.setState({
            selectSubReport,
            selectGeneration,
            autoRep: true,
            oneTime: false,
            disableGen: true,
          });
        });
      });
  }

  getDropList = () => {
    instance.get(`reportrobo/initreportrobo`).then(
      (response) => {
        this.setState(
          {
            ReportCatagory: response.data.result.ReportCatagory,
            GenerationType: response.data.result.GenerationType,
            FrequencyType: response.data.result.FrequencyType,
          },
          () => {
            if (this.props.updateId != null) {
              this.getReportDataById();
            }
          },
        );
      },
      (error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      },
    );
  };

  filterOption({ label, value }, string) {
    if (label.toLocaleLowerCase().includes(string.toLocaleLowerCase())) {
      return true;
    }

    const groupOptions = this.options.filter((group) =>
      group.label.toLocaleLowerCase().includes(string.toLocaleLowerCase()),
    );

    return groupOptions.some((groupOption) =>
      groupOption.options.some((opt) => opt.displayvalue === value),
    );
  }

  getStage = () => {
    instance.get(`superuser/getmastercode/EmployeeStage`).then((response) => {
      response.data &&
        response.data.result.unshift({ displayname: "All", displayvalue: 0 });
      this.setState({ stages: response.data.result });
    });
  };

  getEmployeementtype = () => {
    instance.get(`superuser/getmastercode/EmploymentType`).then((response) => {
      response.data &&
        response.data.result.unshift({ displayname: "All", displayvalue: 0 });
      this.setState({ employeementtype: response.data.result });
    });
  };

  generationTypeOnChange(val) {
    if (val.displayvalue == 1) {
      this.setState({
        selectGeneration: val,
        autoRep: false,
        oneTime: true,
        selectedStage: [
          { displayname: "Probation", displayvalue: 1 },
          { displayname: "Confirmed", displayvalue: 2 },
          { displayname: "Training", displayvalue: 3 },
          { displayname: "PIP", displayvalue: 4 },
          { displayname: "On Notice", displayvalue: 5 },
          { displayname: "Resigned", displayvalue: 6 },
          { displayname: "Terminated", displayvalue: 7 },
          { displayname: "New", displayvalue: 8 },
        ],
        selectedemployeementtype: [
          { displayvalue: 1, displayname: "Full Time" },
          { displayvalue: 2, displayname: "Part Time" },
          { displayvalue: 3, displayname: "Internship" },
          { displayvalue: 4, displayname: "Apprenticeship" },
          { displayvalue: 5, displayname: "Contract" },
          { displayvalue: 6, displayname: "Consultant" },
          { displayvalue: 7, displayname: "Labor" },
          { displayvalue: 8, displayname: "Freelancer" },
          { displayvalue: 9, displayname: "Vendor" },
        ],
      });
    } else if (val.displayvalue == 2) {
      this.setState({
        selectGeneration: val,
        autoRep: true,
        oneTime: false,
        selectedStage: [
          { displayname: "Probation", displayvalue: 1 },
          { displayname: "Confirmed", displayvalue: 2 },
          { displayname: "Training", displayvalue: 3 },
          { displayname: "PIP", displayvalue: 4 },
          { displayname: "On Notice", displayvalue: 5 },
          { displayname: "Resigned", displayvalue: 6 },
          { displayname: "Terminated", displayvalue: 7 },
          { displayname: "New", displayvalue: 8 },
        ],
        selectedemployeementtype: [
          { displayvalue: 1, displayname: "Full Time" },
          { displayvalue: 2, displayname: "Part Time" },
          { displayvalue: 3, displayname: "Internship" },
          { displayvalue: 4, displayname: "Apprenticeship" },
          { displayvalue: 5, displayname: "Contract" },
          { displayvalue: 6, displayname: "Consultant" },
          { displayvalue: 7, displayname: "Labor" },
          { displayvalue: 8, displayname: "Freelancer" },
          { displayvalue: 9, displayname: "Vendor" },
        ],
      });
    }
  }

  reportTypeOnChange(val) {
    this.setState(
      {
        selectReport: val,
        selectSubReport: "",
        oneTime: false,
        autoRep: false,
        selectGeneration: "",
      },
      () => {
        this.getSubReport();
      },
    );
  }

  subReportTypeOnChange(val) {
    if (this.props.updateId == null) {
      this.setState({
        selectSubReport: val,
        oneTime: false,
        autoRep: false,
        selectGeneration: "",
        fromDate: "",
        toDate: "",
        // stages: [],
        // employeementtype: [],
        selectedemployeementtype: [],
        selectedStage: [],
      });
    }
    if (this.props.updateId != null) {
      this.setState({ selectSubReport: val, autoRep: true });
    }

    if (val && [601, 603].some((reportid) => reportid == val.value)) {
      this.getReviewForm();
    }
  }

  getSubReport() {
    instance.get(`reportrobo/reporttypebycategory/`).then(
      (response) => {
        //
        const SubReportCatagory = [];
        response.data.result.forEach((element) => {
          const presentIndex = SubReportCatagory.findIndex(
            (x) => x.label == element.reportcatagoryname,
          );
          if (presentIndex !== -1) {
            SubReportCatagory[presentIndex].options.push({
              ...element,
              label: element.displayname,
              value: element.displayvalue,
            });
          } else {
            SubReportCatagory.push({
              label: element.reportcatagoryname,
              reportcatagoryname: element.reportcatagoryname,
              reportcatagoryid: element.reportcatagoryid,
              options: [
                {
                  ...element,
                  label: element.displayname,
                  value: element.displayvalue,
                },
              ],
            });
          }
        });
        this.setState({ SubReportCatagory }, () => {
          if (this.props.updateId != null) {
            this.getReportDataById();
          }
        });
      },
      (error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      },
    );
  }

  getReviewForm() {
    instance
      .get(`perform/getreviewformlist/null/1`)
      .then((result) => {
        this.setState({
          reviewforms: result.data.result,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  onSelectReviewForm(value) {
    this.setState({
      selectedreviewform: value,
    });
  }

  clearReportType() {
    this.setState(
      {
        selectReport: "",
        selectSubReport: "",
        oneTime: false,
        autoRep: false,
        selectGeneration: "",
        selectedStage: [],
        selectedreviewform: null,
        selectedemployeementtype: [],
        disableGen: false,
      },
      () => {
        if (this.props.permissions.editable) {
          this.props.handleChange(null, 0, null);
        } else {
          this.props.handleChange(null, 1, null);
        }
      },
    );
  }

  render() {
    const { classes } = this.props;
    const language = this.props.Language.reportrobo;
    // const report = [
    //     { displayvalue: 1, displayname: "One Time Report" },
    //     { displayvalue: 2, displayname: "Auto Report" },
    // ];
    return (
      <IntlProvider locale="en" messages={language}>
        <div className={classes.root}>
          <Helmet>
            <title>{headersList.ROBO.header}</title>
          </Helmet>
          <Grid container>
            <Grid item xs={12} md={8} sm={12}>
              <div>
                {/* <div className="opaque">
                  <div className="margin-bottom-20">
                    <p class="add-label-active margin-top-0">
                      <FormattedMessage id="LbReportCategory" defaultMessage="Report Category" />
                    </p>
                    <Select
                      class="form-control"
                      autofocus
                      placeholder="Select Report Category"
                      options={this.state.ReportCatagory}
                      getOptionLabel={option => option.displayname}
                      getOptionValue={option => option.displayvalue}
                      onChange={this.reportTypeOnChange.bind(this)}
                      value={this.state.selectReport}
                    />
                  </div>
                </div> */}
                <div className="opaque">
                  <div className="margin-bottom-20">
                    <p className="add-label-active">Choose your report</p>
                    <Select
                      class="form-control"
                      autofocus
                      placeholder="Select Report Type"
                      filterOption={this.filterOption}
                      options={this.state.SubReportCatagory}
                      getOptionLabel={(option) => option.displayname}
                      getOptionValue={(option) => option.displayvalue}
                      onChange={this.subReportTypeOnChange.bind(this)}
                      value={this.state.selectSubReport}
                    />
                  </div>
                </div>
                {this.state.selectSubReport && (
                  <div>
                    {this.state.selectSubReport.data && (
                      <p className="add-label-active">Data in this report</p>
                    )}
                    {this.state.selectSubReport.data && (
                      <Paper className="rounded-rectangle-paper padding16 margin-bottom-16">
                        {this.state.selectSubReport.data ? (
                          <div
                            className="display-flex width100"
                            style={{ justifyContent: "space-between" }}
                          >
                            <div
                              className="width50"
                              style={{
                                borderRight: "solid 1px #ddd",
                                marginRight: 16,
                              }}
                            >
                              <p
                                className="small-dark t-bold"
                                style={{
                                  borderBottom: "solid 1px #ddd",
                                  marginRight: 16,
                                  paddingBottom: 4,
                                }}
                              >
                                {this.state.selectSubReport &&
                                  this.state.selectSubReport.data &&
                                  this.state.selectSubReport.data.basic &&
                                  this.state.selectSubReport.data.basic
                                    .length}{" "}
                                Basic data
                              </p>
                              <ul
                                className="thin-scroll"
                                style={{
                                  padding: "0 16px",
                                  margin: "4px 0px 0px 0px",
                                  height: 105,
                                  overflowY: "auto",
                                  paddingLeft: 18,
                                }}
                              >
                                {this.state.selectSubReport &&
                                  this.state.selectSubReport.data &&
                                  this.state.selectSubReport.data.basic &&
                                  this.state.selectSubReport.data.basic.map(
                                    (x) => (
                                      <li
                                        style={{ listStyleType: "circle" }}
                                        className="small-dark"
                                      >
                                        {x}
                                      </li>
                                    ),
                                  )}
                              </ul>
                            </div>
                            <div className="width50">
                              <p
                                className="small-dark t-bold"
                                style={{
                                  borderBottom: "solid 1px #ddd",
                                  marginRight: 16,
                                  paddingBottom: 4,
                                }}
                              >
                                {this.state.selectSubReport &&
                                  this.state.selectSubReport.data &&
                                  this.state.selectSubReport.data.contextual &&
                                  this.state.selectSubReport.data.contextual
                                    .length}{" "}
                                Contextual data
                              </p>
                              <ul
                                className="thin-scroll"
                                style={{
                                  padding: "0 16px",
                                  margin: "4px 0px 0px 0px",
                                  height: 105,
                                  overflowY: "auto",
                                  paddingLeft: 18,
                                }}
                              >
                                {this.state.selectSubReport &&
                                  this.state.selectSubReport.data &&
                                  this.state.selectSubReport.data.contextual &&
                                  this.state.selectSubReport.data.contextual.map(
                                    (x) => (
                                      <li
                                        style={{ listStyleType: "circle" }}
                                        className="small-dark"
                                      >
                                        {x}
                                      </li>
                                    ),
                                  )}
                              </ul>
                            </div>
                          </div>
                        ) : (
                          <div style={{ textAlign: "center" }}>
                            <img
                              src={noReportData}
                              style={{ height: 84 }}
                            ></img>
                            <p className="normal-dark t-bold margin-top-16">
                              There is unclassified data in this report!
                            </p>
                          </div>
                        )}
                      </Paper>
                    )}
                    {this.state.selectSubReport ? (
                      <div className="inner-wrapper opaque">
                        <div className="margin-bottom-20">
                          <p className="add-label-active">
                            When do you want this report?
                          </p>
                          <Select
                            class="form-control"
                            autofocus
                            placeholder="Select generation type"
                            options={get(
                              this.state,
                              "GenerationType",
                              [],
                            ).filter(
                              (x) =>
                                get(
                                  this.state,
                                  "selectSubReport.generationtypeids",
                                  "",
                                ).indexOf(x.displayvalue) != -1,
                            )}
                            getOptionLabel={(option) => option.displayname}
                            getOptionValue={(option) => option.displayvalue}
                            onChange={this.generationTypeOnChange.bind(this)}
                            value={this.state.selectGeneration}
                            isDisabled={this.state.disableGen}
                          />
                        </div>
                      </div>
                    ) : null}
                    {this.state.selectGeneration && (
                      <div>
                        {
                          // this.state.selectGeneration &&
                          //   this.state.selectSubReport &&
                          ![501, 603].some(
                            (rpId) => rpId == this.state.selectSubReport.value,
                          ) && (
                            <div className="inner-wrapper opaque">
                              <div className="margin-bottom-20">
                                <p className="add-label-active">
                                  Employees of which employment type should be
                                  included in this report?
                                </p>
                                <Select
                                  class="form-control"
                                  autofocus
                                  placeholder="Select employment type"
                                  options={this.state.employeementtype}
                                  getOptionLabel={(option) =>
                                    option.displayname
                                  }
                                  getOptionValue={(option) =>
                                    option.displayvalue
                                  }
                                  onChange={(e) => {
                                    console.log("e: ", e);
                                    const tempvalue =
                                      e && e.find((x) => x.displayvalue == 0);
                                    if (
                                      tempvalue &&
                                      tempvalue.displayvalue == 0
                                    ) {
                                      const obj = [];
                                      for (const val of this.state
                                        .employeementtype) {
                                        if (val.displayvalue != 0) {
                                          obj.push(val);
                                        }
                                      }
                                      e = obj;
                                    }
                                    this.setState({
                                      selectedemployeementtype: e ? e : [],
                                    });
                                  }}
                                  value={this.state.selectedemployeementtype}
                                  isMulti
                                />
                              </div>
                            </div>
                          )
                        }
                        {
                          // this.state.selectGeneration &&
                          //   this.state.selectSubReport &&
                          ![501, 603].some(
                            (rpId) => rpId == this.state.selectSubReport.value,
                          ) && (
                            <div className="inner-wrapper opaque">
                              <div className="margin-bottom-20">
                                <p className="add-label-active">
                                  Employees at which stage(s) should be included
                                  in this report?
                                </p>
                                <Select
                                  class="form-control"
                                  autofocus
                                  placeholder="Select stage(s)"
                                  options={this.state.stages}
                                  getOptionLabel={(option) =>
                                    option.displayname
                                  }
                                  getOptionValue={(option) =>
                                    option.displayvalue
                                  }
                                  onChange={(e) => {
                                    console.log("e: ", e);
                                    const tempvalue = e.find(
                                      (x) => x.displayvalue == 0,
                                    );
                                    if (
                                      tempvalue &&
                                      tempvalue.displayvalue == 0
                                    ) {
                                      const obj = [];
                                      for (const val of this.state.stages) {
                                        if (val.displayvalue != 0) {
                                          obj.push(val);
                                        }
                                      }
                                      e = obj;
                                    }
                                    this.setState({
                                      selectedStage: e ? e : [],
                                    });
                                  }}
                                  value={this.state.selectedStage}
                                  isMulti
                                  // isDisabled={this.state.disableGen}
                                />

                                {/* </Select> */}
                              </div>
                            </div>
                          )
                        }
                        {
                          // this.state.selectGeneration &&
                          //   this.state.selectSubReport &&
                          [601, 603].some(
                            (reportid) =>
                              reportid == this.state.selectSubReport.value,
                          ) && (
                            <div className="inner-wrapper opaque">
                              <div className="margin-bottom-20">
                                <p className="add-label-active">
                                  Select Review Form
                                </p>
                                <Select
                                  class="form-control"
                                  autofocus
                                  placeholder="Select Review From"
                                  options={this.state.reviewforms}
                                  getOptionLabel={(option) =>
                                    option.displayname
                                  }
                                  getOptionValue={(option) =>
                                    option.displayvalue
                                  }
                                  onChange={(e) => this.onSelectReviewForm(e)}
                                  value={this.state.selectedreviewform}
                                  // isDisabled={this.state.disableGen}
                                />

                                {/* </Select> */}
                              </div>
                            </div>
                          )
                        }
                        {
                          // this.state.selectedStage.length > 0 &&
                          this.state.autoRep ? (
                            <AutoReport
                              {...this.state}
                              {...this.props}
                              FrequencyType={get(
                                this.state,
                                "FrequencyType",
                                "",
                              ).filter(
                                (x) =>
                                  get(
                                    this.state,
                                    "selectSubReport.frequencytypeids",
                                    "",
                                  ).indexOf(x.displayvalue) != -1,
                              )}
                              reportcatagoryid={get(
                                this.state,
                                "selectSubReport.reportcatagoryid",
                                "",
                              )}
                              reporttypeid={get(
                                this.state,
                                "selectSubReport.displayvalue",
                                "",
                              )}
                              generationtypeid={get(
                                this.state,
                                "selectGeneration.displayvalue",
                                "",
                              )}
                              permissions={get(this.props, "permissions", "")}
                              updateId={get(this.props, "updateId", null)}
                              updateData={get(this.state, "updateData", "")}
                              clearReportType={() => this.clearReportType()}
                              _setState={this._setState}
                              saveReportFlag={this.state.saveReportFlag}
                            />
                          ) : null
                        }
                        {get(this.state, "selectGeneration.displayvalue", "") ==
                          1 &&
                          (this.state.selectedStage.length > 0 ||
                            (this.state.selectSubReport &&
                              [501, 603].some(
                                (rpId) =>
                                  rpId == this.state.selectSubReport.value,
                              ))) && (
                            <SendReport
                              {...this.props}
                              {...this.state}
                              reportcatagoryid={get(
                                this.state,
                                "selectSubReport.reportcatagoryid",
                                "",
                              )}
                              reporttypeid={get(
                                this.state,
                                "selectSubReport.displayvalue",
                                "",
                              )}
                              generationtypeid={get(
                                this.state,
                                "selectGeneration.displayvalue",
                                "",
                              )}
                              permissions={get(this.props, "permissions", "")}
                              updateId={get(this.props, "updateId", null)}
                              updateData={get(this.state, "updateData", "")}
                              clearReportType={() => this.clearReportType()}
                              _setState={this._setState}
                              hideSave
                            />
                          )}
                        {(this.state.selectedStage.length > 0 ||
                          (this.state.selectSubReport &&
                            [501, 603].some(
                              (rpId) =>
                                rpId == this.state.selectSubReport.value,
                            ))) &&
                          get(this.state, "oneTime", "") && (
                            <OneTimeReport
                              {...this.state}
                              {...this.props}
                              permissions={get(this.props, "permissions", "")}
                              FrequencyType={get(
                                this.state,
                                "FrequencyType",
                                [],
                              ).filter(
                                (x) =>
                                  get(
                                    this.state,
                                    "selectSubReport.frequencytypeids",
                                    "",
                                  ).indexOf(x.displayvalue) != -1,
                              )}
                              reportcatagoryid={get(
                                this.state,
                                "selectSubReport.reportcatagoryid",
                                "",
                              )}
                              reporttypeid={get(
                                this.state,
                                "selectSubReport.displayvalue",
                                "",
                              )}
                              generationtypeid={get(
                                this.state,
                                "selectGeneration.displayvalue",
                                "",
                              )}
                              daterangeids={get(
                                this.state,
                                "selectSubReport.daterangeids",
                                "",
                              )}
                              clearReportType={() => this.clearReportType()}
                              _setState={this._setState}
                            />
                          )}
                        <div />
                      </div>
                    )}
                  </div>
                )}
                {get(this.state, "selectGeneration.displayvalue", "") &&
                  (this.state.selectedStage.length > 0 ||
                    (this.state.selectSubReport &&
                      [501, 603].some(
                        (rpId) => rpId == this.state.selectSubReport.value,
                      ))) && (
                    <div className="margin-top-90 margin-bottom-30">
                      <Button
                        variant="contained"
                        color="primary"
                        className="btn btn-primary-md-blue"
                        size="large"
                        onClick={() => {
                          this._setState("saveReportFlag", true);
                        }}
                      >
                        <FormattedMessage id="BtSave" defaultMessage="Save" />
                      </Button>
                    </div>
                  )}
              </div>
            </Grid>
          </Grid>
        </div>
      </IntlProvider>
    );
  }
}

ReportRobo.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(ReportRobo)));
